import { Component, HostListener, OnInit } from "@angular/core";
import { Validators, FormGroup, FormsModule, ReactiveFormsModule, FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { authService } from "../shared/services/auth.service";
import { PermissionService } from "../shared/services/permission.service";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalConstants } from "../shared/Constants/global.constants";


@Component({
  selector: "app-login",
  imports:[FormsModule,ReactiveFormsModule],
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public newUser = false;
  public loginForm: FormGroup;
  public show: boolean = false
  public errorMessage: any;

  constructor(private fb: FormBuilder, public router: Router, private toaster: ToastrService,
    private authservice: authService, private spinner: NgxSpinnerService, private permissionService: PermissionService
  ) {
    this.loginForm = this.fb.group({
      UserName: [""],
      email: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required],
    });
  }

  ngOnInit() {}

   login(): void {
    if (this.loginForm.invalid) {
      this.toaster.error('Please fill in all required fields correctly.', 'Invalid Input');
      return;
    }
 
    this.spinner.show();
    const credentials = this.loginForm.value;
 
    this.authservice.authenticateUser(credentials).subscribe({
      next: (data) => {
        this.spinner.hide();
        let response= JSON.parse(data.externalResponse);
 
        if (response?.IsSuccess && response?.Data?.Data?.Token) {
          const userData = response.Data.Data;
          const permissions = response.Data.Permissions || [];
          const permissionHierarchy = response.Data.PermissionHierarchy || [];
          const Subscription = response.Data.Subscription || [];
 
          // Save basic user data
          localStorage.setItem('token', userData.Token);
          localStorage.setItem('userData', JSON.stringify(userData));
          localStorage.setItem('Subscription', JSON.stringify(Subscription));
          localStorage.setItem('permissions', JSON.stringify(permissions));
          localStorage.setItem('PermissionHierarchy', JSON.stringify(permissionHierarchy));
 
          // Use PermissionService to process and save permissions
          this.permissionService.processAndSavePermissions(permissions);
 
          // Redirect based on permissions
          this.redirectUser(permissions);
 
        } else {
          console.error(response?.Message || 'Login failed');
          this.toaster.error(response?.Message || 'Login failed');
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.toaster.error('An error occurred during login');
        console.error('Login error:', error);
      }
    });
  }
 
  redirectUser(permissions: any[]): void {
    if (permissions.length > 0) {
      
      this.router.navigate(['/device-map']);
    } else {
      // If no permissions, show error and stay on login page
      this.toaster.error(
        'Your account has no permissions. Contact the administrator.',
        'Access Denied'
      );
    }
  }
 
      
    
   
  
  showPassword(){
    this.show = !this.show
  }

  deferredPrompt: any; 
  showInstallPrompt: boolean = false; 
  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: any) {
    event.preventDefault();
    this.deferredPrompt = event;
    this.showInstallPrompt = true;
  }

  installApp() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt(); 
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        this.showInstallPrompt = false; 
      });
    }
  }

  
  closeInstallPrompt() {
    this.showInstallPrompt = false;
  }

   showPrivacyPolicy() {
    const privacyPolicyUrl = GlobalConstants.PrivacyPolicyURL;
    window.open(privacyPolicyUrl, '_blank');
  }

}
